<template>
  <div class="col-10 col-md-8 offset-1 offset-md-2">
    <div class="row">
      <div class="d-none d-md-flex col-md-6 p-0">
        <img
          class="w-100 h-100 object-fit-cover"
          src="images/forgot-password.png"
        />
      </div>
      <div class="col-12 col-md-6 p-5 bg-white">
        <p>
          {{ $t("reset.title") }}
        </p>
        <p>{{ $t("reset.reset_message") }}</p>
        <b-form-group :label="$t('field.email')">
          <b-form-input
            v-model="$v.email.$model"
            :class="{ 'border border-danger': $v.email.$error }"
            name="email"
            type="email"
            required
            placeholder="lorem@ipsum.dolor"
          />
          <li class="text-danger list-group-item px-0 border-0 py-0">
            <span v-if="!$v.email.$error">&nbsp;</span>
            <span v-else-if="!$v.email.required" class="small text-danger">{{
              $t("form.required")
            }}</span>
            <span v-else-if="!$v.email.email" class="small text-danger">{{
              $t("form.required")
            }}</span>
          </li>
        </b-form-group>
        <div class="row">
          <div class="col-12 align-items-end justify-content-center d-flex">
            <b-button variant="primary" class="px-5" @click.stop="reset">
              {{ $t("reset.reset_password") }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required, email } from 'vuelidate/lib/validators'
import api from '@/api/users'

export default {
  data: () => ({
    email: null,
    api: api
  }),
  methods: {
    async reset() {
      if (this.$v.$invalid) {
        this.$toasted.error(this.$t('form.error'))
        return
      }

      try {
        const response = await this.api.resetSendLink({ email: this.email })

        if (response && response.data) {
          this.$toasted.success(this.$t('reset.reset_sent'))
          this.$router.push({ name: 'login' })
        } else if (
          response &&
          response.response &&
          response.response.data &&
          response.response.data.message
        ) {
          this.$toasted.error(this.$t(response.response.data.message))
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        this.$toasted.error(this.$t(e))
      }
    }
  },
  validations: {
    email: {
      required,
      email
    }
  }
}
</script>
